// internal dependencies
import GetCardList from '../../../routes/get-card-list';

/**
 * Prepares the model data for the card list api.
 * 
 * @return the api response data that is to be display in table format.
 */
export const getCardListData = async (): Promise<any> => {
  try {
    const { body } = await GetCardList();

    return body;
  } catch (error) {
    console.error("Error fetching card list data:", error);
    return [];
  }
};